<template>
  <div class='chart'>
    <graph-bar ref="graph3"
      label="Assolement (en ha)"
      :loadDataFn="loadResultForGraph"
      type="surface"
      v-tooltip="{ content : getTooltipMessage('graph_assolement') }"
    />
    <graph-box-plot ref="graph1"
      v-show="!avecAide"
      label="Marge nette (en k€)"
      :loadDataFn="loadResultForGraph"
      type="mn"
      :annotationValue="objectif"
      annotationTitle="Objectif"
      v-tooltip="{ content : getTooltipMessage('graph_marge') }">
      <label slot="header">
        <input type="checkbox" v-model="avecAide"/>Aide incluse
      </label>
    </graph-box-plot>
    <graph-box-plot ref="graph1"
      v-show="avecAide"
      label="Marge nette (en k€)"
      :loadDataFn="loadResultForGraph"
      type="mn_aide"
      :annotationValue="objectif"
      annotationTitle="Objectif"
      v-tooltip="{ content : getTooltipMessage('graph_marge') }">
      <label slot="header">
        <input type="checkbox" v-model="avecAide"/>Aide incluse
      </label>
    </graph-box-plot>
    <graph-box-plot
      ref="graph2"
      label="Consommation en eau (en milliers de m³)"
      :loadDataFn="loadResultForGraph"
      :annotationValue="volumeIrrigation"
      annotationTitle="Vol. Irr."
      type="conso"
      v-tooltip="{ content : getTooltipMessage('graph_conso') }"
    />
    <graph-box-plot
      v-if="hasCultureFilter"
      ref="graph5"
      label="Rendement (q/ha)"
      annotationTitle="Rdt. potentiel"
      :annotationValue="rdtPotentiel"
      :loadDataFn="loadResultForRendement"
      type="rendement"
      :group="true"
      v-tooltip="{ content : getTooltipMessage('graph_rendement') }"
    />
    <graph-bar
      ref="graph4"
      label="Temps de travail (en h)"
      :loadDataFn="loadResultForGraph"
      type="temps"
      v-tooltip="{ content : getTooltipMessage('graph_temps') }"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import GraphBoxPlot from './GraphBoxPlot'
import GraphBar from './GraphBar'
import mixinTooltip from '@/mixins/tooltip'

export default {

  name: 'resultatGraphique',
  mixins: [mixinTooltip],

  data () {
    return {
      avecAide: true,
      rdtPotentiel: null
    }
  },

  computed: {
    hasIlotFilter () {
      return this.$store.state.simulation.filtreIlot.id_ilot != null
    },
    hasCultureFilter () {
      return this.$store.state.simulation.filtreCulture.id_culture != null
    },
    hasFilter () {
      return this.hasIlotFilter || this.hasCultureFilter
    },
    objectif () {
      return this.avecAide && !this.hasFilter ? this.$store.state.exploitation.information.objectif / 1000 : null
    },
    ilots () {
      return this.$store.getters.ilots
    },
    valeurAide () {
      if (!this.avecAide) {
        return 0
      }
      return this.$store.state.exploitation.information.dpb
    },
    volumeIrrigation () {
      let volume = this.$store.state.simulation.filtreIlot.volume_irrigation || 0
      return volume !== 0 ? volume / 1000 : null
    }
  },

  methods: {
    ...mapActions(['loadResultForGraph']),
    loadResultForRendement (param) {
      const p = this.loadResultForGraph(param)
      p.then(data => {
        const sols = this.$store.getters.getSolCultureById(this.$store.state.simulation.filtreCulture.id_culture)
        const typeSol = ([...new Set((data || [])
          .map(trace => [...new Set(trace.x)])
          .reduce((acc, val) => acc.concat(val), [])
        )])
        this.rdtPotentiel = typeSol.map(typeSol => (sols.filter(s => s.nom === typeSol).pop() || {}).rendement)
      })
      return p
    },
    loadResult () {
      this.$refs.graph1.loadData()
      this.$refs.graph2.loadData()
      this.$refs.graph3.loadData()
      this.$refs.graph4.loadData()
      this.$refs.graph5 && this.$refs.graph5.loadData()
    }
  },

  components: {
    GraphBoxPlot, GraphBar
  }
}

</script>

<style lang="scss">
  .chart {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    & > * {
      flex: 1;
      height: 30em;
      max-width: 50%;
      min-width: 45%;
    }
  }
</style>
